module.exports = __webpack_public_path__ + "assets/img/afrs_preview.1420c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/afrs_preview.png
// module id = 44
// module chunks = 0